import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Component({
  selector: 'mmx-email-preview',
  templateUrl: './email-preview-dialog.component.html',
  styleUrls: ['./email-preview-dialog.component.scss'],
  standalone: false,
})
export class EmailPreviewDialogComponent {
  sanitizedContent: SafeHtml
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {emailContent: string},
    private sanitizer: DomSanitizer,
  ) {
    this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(data.emailContent)
  }
}
